import request from '../util/http'

//fileId
export function queryByFileId(params) {
  return request({
    url: '/zcjf/base/file/queryByFileId',
    method: 'get',
    params,
  })
}
